export default "__VITE_ASSET__CHgi9Nn2__"